
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gMoJ7RBpmtYLTpwZkZYo9wGYeKYfw3E0VQrNChRGsJmwMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexRZoG2Li7ZBEmRj8DRJSGmbUGv8TYEUfd7W1Mbzm5so4Meta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchleEVbzKkW3rBBO4YubssphltlCI4kBZhiJPtpEgSCbUMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index1ua_45ue5SHXK7ZDTYfcRdm2E_45RYwUcGkPwm9UUA4QDxMMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_933kkAjCLMu3fsA2WK049bu2XA_uD9GQ8ShBqNnflgDfEMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index8Kw0fIeCU1NhJC_WreA4NR_45LiQ1JW_IJBRty0LsGwz0Meta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93tJXOagzXRWKABvWZUvCRAODEfrRagM4CSCr_45Temb1wMMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexgknEdTw4GssGchWauA9RvCLcQOHBecHplQHK1dOPb9AMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93cmHqHLB2GwnVxLx3z_EhSyzZ1TTCG7XrtAvdwWcd_45jwMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexyu7eTQp70vZrT3CBohNUh9iPvG9aONdw7bzhTj2vNmIMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexYKKUJbEwIaY5iTUM9WAJtO1TorEM_45lmXgSRwqxGGVdEMeta } from "/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index8Kw0fIeCU1NhJC_WreA4NR_45LiQ1JW_IJBRty0LsGwz0Meta || {},
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexgknEdTw4GssGchWauA9RvCLcQOHBecHplQHK1dOPb9AMeta || {},
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexyu7eTQp70vZrT3CBohNUh9iPvG9aONdw7bzhTj2vNmIMeta || {},
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexYKKUJbEwIaY5iTUM9WAJtO1TorEM_45lmXgSRwqxGGVdEMeta || {},
    component: () => import("/codebuild/output/src2049518686/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]